import { COMPONENT_DID_CATCH } from 'Global/Stores/errors'
import { SIGN_IN_FULFILLED, SIGN_IN_LS, SIGN_OUT } from 'Global/Stores/auth'

const ga = window.ga

const makeStartsWith = action => prefix => action.startsWith(prefix)

export const sendEvent = (action, payload = '', meta = '') => {
  const startsWith = makeStartsWith(action)

  if (startsWith(COMPONENT_DID_CATCH)) {
    return sendException(payload, true)
  }

  if (startsWith('REJECTED_API|')) {
    return sendException({ error: 'API Rejection', info: meta.url }, false)
  }

  if (startsWith(SIGN_IN_LS)) {
    return ga('send', {
      hitType: 'event',
      eventCategory: 'Auth',
      eventAction: 'Sign In',
      eventLabel: 'Local Storage',
    })
  }

  if (startsWith(SIGN_IN_FULFILLED)) {
    return ga('send', {
      hitType: 'event',
      eventCategory: 'Auth',
      eventAction: 'Sign In',
      eventLabel: 'Form',
    })
  }

  if (startsWith(SIGN_OUT)) {
    return ga('send', {
      hitType: 'event',
      eventCategory: 'Auth',
      eventAction: 'Sign Out',
      eventLabel: 'Signed out',
    })
  }

  if (startsWith('API|')) {
    return ga('send', {
      hitType: 'event',
      eventCategory: 'API',
      eventAction: meta.method ? meta.method : 'get',
      eventLabel: meta.url,
    })
  }

  if (startsWith('@@router/LOCATION_CHANGE')) {
    return ga('send', {
      hitType: 'event',
      eventCategory: 'Router',
      eventAction: 'Navigation',
      eventLabel: payload.pathname,
    })
  }

  if (startsWith('LAYOUT/')) {
    return ga('send', {
      hitType: 'event',
      eventCategory: 'User Action',
      eventAction: 'Layout Change',
      eventLabel: action,
    })
  }

  if (startsWith('PENDING_API|') || startsWith('FULFILLED_API|')) {
    return
  }

  return ga('send', {
    hitType: 'event',
    eventCategory: 'Uncategorized',
    eventAction: action,
    eventLabel: payload.toString(),
  })

  /*
    Automatic Action
    CallToApi
    UserAction
    Error
  */
}

const sendException = ({ error, info }, fatal) =>
  ga('send', 'exception', {
    exDescription: `${error}
    ${info}`,
    exFatal: fatal,
  })
